import { render } from "./ImportPriceLists.vue?vue&type=template&id=5e095036&scoped=true"
import script from "./ImportPriceLists.vue?vue&type=script&lang=js"
export * from "./ImportPriceLists.vue?vue&type=script&lang=js"

import "./ImportPriceLists.vue?vue&type=style&index=0&id=5e095036&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e095036"]])

export default __exports__